/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise'
import type { BaseHttpRequest } from '../core/BaseHttpRequest'
export class SystemService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * Heartbeat endpoint.
   * @returns any Server is up.
   * @throws ApiError
   */
  public getHeartbeat(): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/v2/heartbeat'
    })
  }
}
